// Chat "message sent" sound (mobile: src/utils/sendSound.js): one soft 200 ms
// tap, public/assets/sounds/message_send.wav (synthesised for Kjuup).
//
// Rules, as on mobile: quiet (volume 0.4), never while a call runs in this
// browser (the call tab registers itself in `kjuup_my_active_calls`, see
// utils/callTab.js), at most one tap per 250 ms (a batch of attachments or a
// double click on Send play once), and any failure is silent: sending never
// depends on it.

const SOUND_URL = `${process.env.PUBLIC_URL || ""}/assets/sounds/message_send.wav`;
const VOLUME = 0.4;
const MIN_GAP_MS = 250;
const ACTIVE_CALLS_KEY = "kjuup_my_active_calls";
const CALL_TTL_MS = 6 * 60 * 60 * 1000;

let audio = null;
let lastPlayedAt = 0;

function hasActiveCall() {
  try {
    const raw = localStorage.getItem(ACTIVE_CALLS_KEY);
    if (!raw) return false;
    const map = JSON.parse(raw) || {};
    const now = Date.now();
    return Object.keys(map).some((key) => map[key] && now - map[key] < CALL_TTL_MS);
  } catch (_) {
    return false;
  }
}

function getAudio() {
  if (audio || typeof Audio === "undefined") return audio;
  try {
    audio = new Audio(SOUND_URL);
    audio.preload = "auto";
    audio.volume = VOLUME;
  } catch (_) {
    audio = null;
  }
  return audio;
}

/** Loads the sound once, so the first send already plays it. */
export function preloadSendSound() {
  const a = getAudio();
  if (a && typeof a.load === "function") {
    try {
      a.load();
    } catch (_) {
      /* ignore */
    }
  }
}

/** Plays the send tap (see the rules above). */
export function playSendSound() {
  const now = Date.now();
  if (now - lastPlayedAt < MIN_GAP_MS) return;
  if (hasActiveCall()) return;
  const a = getAudio();
  if (!a) return;
  lastPlayedAt = now;
  try {
    a.currentTime = 0;
    const p = a.play();
    if (p && typeof p.catch === "function") p.catch(() => {});
  } catch (_) {
    /* ignore */
  }
}
